import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateDeviceDetectionJobByIdMutationVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
  _set?: Types.InputMaybe<Types.Device_Detection_Jobs_Set_Input>;
}>;


export type UpdateDeviceDetectionJobByIdMutation = { __typename?: 'mutation_root', update_device_detection_jobs_by_pk?: { __typename?: 'device_detection_jobs', id: any, workspace_id?: any | null, status: string, input_files?: any | null, ai_response?: any | null, detected_devices?: any | null, detected_installed_products?: any | null, products_grouped_by_type?: any | null, created_at?: any | null, updated_at: any, property_id: any, organization_id?: any | null, created_by_user_id?: string | null, property: { __typename?: 'properties', id: any, name: string, address?: string | null, address_id?: any | null, photo_link?: string | null, standardized_address?: { __typename?: 'addresses', id: any, street_1: string, street_2?: string | null, city: string, state: string, postal_code: string, country: string } | null }, organization?: { __typename?: 'organizations', id: any, name: string, type?: string | null, organizationImageURL?: string | null } | null, author?: { __typename?: 'users', first_name: string, last_name: string, email: string } | null } | null };


export const UpdateDeviceDetectionJobByIdDocument = gql`
    mutation updateDeviceDetectionJobById($id: uuid!, $_set: device_detection_jobs_set_input = {}) {
  update_device_detection_jobs_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
    workspace_id
    status
    input_files
    ai_response
    detected_devices
    detected_installed_products
    products_grouped_by_type
    created_at
    updated_at
    property_id
    property {
      id
      name
      address
      address_id
      standardized_address {
        id
        street_1
        street_2
        city
        state
        postal_code
        country
      }
      photo_link
    }
    organization_id
    organization {
      id
      name
      type
      organizationImageURL
    }
    created_by_user_id
    author {
      first_name
      last_name
      email
    }
  }
}
    `;
export type UpdateDeviceDetectionJobByIdMutationFn = Apollo.MutationFunction<UpdateDeviceDetectionJobByIdMutation, UpdateDeviceDetectionJobByIdMutationVariables>;

/**
 * __useUpdateDeviceDetectionJobByIdMutation__
 *
 * To run a mutation, you first call `useUpdateDeviceDetectionJobByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeviceDetectionJobByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeviceDetectionJobByIdMutation, { data, loading, error }] = useUpdateDeviceDetectionJobByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdateDeviceDetectionJobByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDeviceDetectionJobByIdMutation, UpdateDeviceDetectionJobByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDeviceDetectionJobByIdMutation, UpdateDeviceDetectionJobByIdMutationVariables>(UpdateDeviceDetectionJobByIdDocument, options);
      }
export type UpdateDeviceDetectionJobByIdMutationHookResult = ReturnType<typeof useUpdateDeviceDetectionJobByIdMutation>;
export type UpdateDeviceDetectionJobByIdMutationResult = Apollo.MutationResult<UpdateDeviceDetectionJobByIdMutation>;
export type UpdateDeviceDetectionJobByIdMutationOptions = Apollo.BaseMutationOptions<UpdateDeviceDetectionJobByIdMutation, UpdateDeviceDetectionJobByIdMutationVariables>;